module.exports = __webpack_public_path__ + "img/27ne.62ade03d.svg";